import qs from "qs";

type TGetDataPositionsParams = {
  page?: number;
  count?: number;
  searchText?: string;
  instanceIds?: (string | number)[];
};

export async function getDataPositions(
  date,
  statuses,
  params: TGetDataPositionsParams = {}
) {
  try {
    const urlParams = qs.stringify({
      actualOn: date,
      statuses,
      page: params.page,
      count: params.count,
      searchText: params.searchText || undefined,
      instanceIds: params.instanceIds?.length
        ? params.instanceIds
        : undefined,
    });

    const response = await fetch(
      `/internal-api/employee/positions?${urlParams}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Ошибка: ", error);
  }
}
